/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdjuntoArticuloModelDto } from '../models/adjunto-articulo-model-dto';
import { articulosControllerObtenerAdjuntoArticulo } from '../fn/paciente-articulos/articulos-controller-obtener-adjunto-articulo';
import { ArticulosControllerObtenerAdjuntoArticulo$Params } from '../fn/paciente-articulos/articulos-controller-obtener-adjunto-articulo';
import { articulosControllerObtenerArticulosPorId } from '../fn/paciente-articulos/articulos-controller-obtener-articulos-por-id';
import { ArticulosControllerObtenerArticulosPorId$Params } from '../fn/paciente-articulos/articulos-controller-obtener-articulos-por-id';
import { articulosControllerObtenerArticulosPorPrograma } from '../fn/paciente-articulos/articulos-controller-obtener-articulos-por-programa';
import { ArticulosControllerObtenerArticulosPorPrograma$Params } from '../fn/paciente-articulos/articulos-controller-obtener-articulos-por-programa';
import { InformacionArticuloDto } from '../models/informacion-articulo-dto';
import { ListadoProgramaArticulosModel } from '../models/listado-programa-articulos-model';

@Injectable({ providedIn: 'root' })
export class PacienteArticulosService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `articulosControllerObtenerArticulosPorPrograma()` */
  static readonly ArticulosControllerObtenerArticulosPorProgramaPath = '/api/articulos/obtener-articulos';

  /**
   * Obtener artículos del usuario agrupados por programa.
   *
   * Devuelve los artículos del usuario organizados por programa.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articulosControllerObtenerArticulosPorPrograma()` instead.
   *
   * This method doesn't expect any request body.
   */
  articulosControllerObtenerArticulosPorPrograma$Response(params?: ArticulosControllerObtenerArticulosPorPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListadoProgramaArticulosModel>>> {
    return articulosControllerObtenerArticulosPorPrograma(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener artículos del usuario agrupados por programa.
   *
   * Devuelve los artículos del usuario organizados por programa.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articulosControllerObtenerArticulosPorPrograma$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articulosControllerObtenerArticulosPorPrograma(params?: ArticulosControllerObtenerArticulosPorPrograma$Params, context?: HttpContext): Observable<Array<ListadoProgramaArticulosModel>> {
    return this.articulosControllerObtenerArticulosPorPrograma$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ListadoProgramaArticulosModel>>): Array<ListadoProgramaArticulosModel> => r.body)
    );
  }

  /** Path part for operation `articulosControllerObtenerArticulosPorId()` */
  static readonly ArticulosControllerObtenerArticulosPorIdPath = '/api/articulos/obtener-articulos/{uuidArticulo}';

  /**
   * Obtener artículos agrupados por programa.
   *
   * Devuelve los artículos organizados por programa.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articulosControllerObtenerArticulosPorId()` instead.
   *
   * This method doesn't expect any request body.
   */
  articulosControllerObtenerArticulosPorId$Response(params: ArticulosControllerObtenerArticulosPorId$Params, context?: HttpContext): Observable<StrictHttpResponse<InformacionArticuloDto>> {
    return articulosControllerObtenerArticulosPorId(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener artículos agrupados por programa.
   *
   * Devuelve los artículos organizados por programa.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articulosControllerObtenerArticulosPorId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articulosControllerObtenerArticulosPorId(params: ArticulosControllerObtenerArticulosPorId$Params, context?: HttpContext): Observable<InformacionArticuloDto> {
    return this.articulosControllerObtenerArticulosPorId$Response(params, context).pipe(
      map((r: StrictHttpResponse<InformacionArticuloDto>): InformacionArticuloDto => r.body)
    );
  }

  /** Path part for operation `articulosControllerObtenerAdjuntoArticulo()` */
  static readonly ArticulosControllerObtenerAdjuntoArticuloPath = '/api/articulos/obtener-adjunto-articulo/{uuidArticulo}';

  /**
   * Obtener adjunto de un artículo.
   *
   * Devuelve el adjunto de un artículo
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articulosControllerObtenerAdjuntoArticulo()` instead.
   *
   * This method doesn't expect any request body.
   */
  articulosControllerObtenerAdjuntoArticulo$Response(params: ArticulosControllerObtenerAdjuntoArticulo$Params, context?: HttpContext): Observable<StrictHttpResponse<AdjuntoArticuloModelDto>> {
    return articulosControllerObtenerAdjuntoArticulo(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener adjunto de un artículo.
   *
   * Devuelve el adjunto de un artículo
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articulosControllerObtenerAdjuntoArticulo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articulosControllerObtenerAdjuntoArticulo(params: ArticulosControllerObtenerAdjuntoArticulo$Params, context?: HttpContext): Observable<AdjuntoArticuloModelDto> {
    return this.articulosControllerObtenerAdjuntoArticulo$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdjuntoArticuloModelDto>): AdjuntoArticuloModelDto => r.body)
    );
  }

}
